/** Rows a long list renders before a "Show more" button (users list, group tree columns). */
export const LIST_PAGE_SIZE = 100;

/** Options an Autocomplete renders at once; typing narrows the rest (group pickers hold up to 10,000). */
export const AUTOCOMPLETE_OPTION_LIMIT = 100;
